import { urlCustomerDelete, urlCustomerDeleteV2, urlCustomerUpdatePasswordV2, urlCustomerUpdateV2, urlCustomerVerifyOtpV2 } from "@/api/endpoint";
import { isAuthenticated } from "@/event/account/auth/authentification";
import { otpValide } from "@/event/opt/otpValide";
import { alertMessageEmptyHappy, alertMessageHappy, showAlertMessageHappy } from "@/happyTheme/event/dashboard/alert/AlertMessageHappy";
import { requestDeleteCustomer } from "@/happyTheme/event/dashboard/user/requestDeleteCustomer";
import type { DataUpdateCustomer } from "@/happyTheme/interfaces/dashboard/information/dataUpdateCustomer";
import { TimeOutClass } from "@/happyTheme/services/timeout/TimeOutClass"
import customer from "@/storage/customer";
import { fetchPostAuthorizationCSRFV2 } from "@/utils/fetch/fetchPostAuthorizationCSRFV2";
import type { Router } from "vue-router";

export class UserService {
    timeOut: TimeOutClass
    messageCatchError = {
        title: "Erreur",
        message: "Une erreur est survenue, veuillez réessayer plus tard.",
        class: "error",
        errors: []
    }

    constructor() {
        this.timeOut = TimeOutClass.getInstance();
    }

    public async updateCustomer(data: DataUpdateCustomer): Promise<any> {
        try {
            const response = await fetchPostAuthorizationCSRFV2(urlCustomerUpdateV2, data)

            alertMessageHappy.value = response;
            alertMessageHappy.value.title = "Informations personnelles";

            const showTimeOut = setTimeout(() => {
                showAlertMessageHappy.value = true;
            }, 100);
            this.timeOut.setTimeoutWithKey("show", showTimeOut);

            const idTimeOut = setTimeout(() => {
                showAlertMessageHappy.value = false;
                setTimeout(() => {
                    alertMessageHappy.value = alertMessageEmptyHappy
                }, 500)
            }, 2000)
            this.timeOut.setIdTimeout(idTimeOut);

            if (response.class === "success") {
                otpValide.value = false;
                const currentCustomerData = customer.getCustomerData();

                customer.setCustomerData({
                    ...currentCustomerData,
                    customer_id: currentCustomerData.customer_id || 0,
                    firstname: data.firstname,
                    lastname: data.lastname,
                    email: data.email,
                    telephone: data.telephone,
                    store_id: currentCustomerData.store_id || 0,
                    language_id: currentCustomerData.language_id || 0,
                    address_id: currentCustomerData.address_id || 0,
                    status: currentCustomerData.status || 0,
                    session_id: currentCustomerData.session_id || '',
                })
            }

            return response;
        } catch (error) {
            // console.log(error)
            alertMessageHappy.value = this.messageCatchError;

            const showTimeOut = setTimeout(() => {
                showAlertMessageHappy.value = true;
            }, 100);
            this.timeOut.setTimeoutWithKey("show", showTimeOut);

            const idTimeOut = setTimeout(() => {
                showAlertMessageHappy.value = false;
                setTimeout(() => {
                    alertMessageHappy.value = alertMessageEmptyHappy
                }, 500)
            }, 2000)
            this.timeOut.setIdTimeout(idTimeOut);
        }
    }

    public async updatePassword(data: object): Promise<any> {
        try {
            const response = await fetchPostAuthorizationCSRFV2(urlCustomerUpdatePasswordV2, data);

            alertMessageHappy.value = response;
            alertMessageHappy.value.title = "Mot de passe";

            const showTimeOut = setTimeout(() => {
                showAlertMessageHappy.value = true;
            }, 100);
            this.timeOut.setTimeoutWithKey("show", showTimeOut);

            const idTimeOut = setTimeout(() => {
                showAlertMessageHappy.value = false;
                setTimeout(() => {
                    alertMessageHappy.value = alertMessageEmptyHappy
                }, 500)
            }, 2000)
            this.timeOut.setIdTimeout(idTimeOut);

            if (response.class === "success") {
                otpValide.value = false;
            }

            return response;

        } catch (error) {
            alertMessageHappy.value = this.messageCatchError;

            const showTimeOut = setTimeout(() => {
                showAlertMessageHappy.value = true;
            }, 100);
            this.timeOut.setTimeoutWithKey("show", showTimeOut);

            const idTimeOut = setTimeout(() => {
                showAlertMessageHappy.value = false;
                setTimeout(() => {
                    alertMessageHappy.value = alertMessageEmptyHappy
                }, 500)
            }, 2000)
            this.timeOut.setIdTimeout(idTimeOut);
        }
    }

    public deleteCustomer(data: object, router: Router) {
        return fetchPostAuthorizationCSRFV2(urlCustomerDeleteV2, data)
            .then(response => {
                alertMessageHappy.value = response;
                alertMessageHappy.value.title = "Suppression du compte";

                const showTimeOut = setTimeout(() => {
                    showAlertMessageHappy.value = true;
                    const idTimeOut = setTimeout(() => {
                        showAlertMessageHappy.value = false;
                        setTimeout(() => {
                            alertMessageHappy.value = alertMessageEmptyHappy
                        }, 500)
                    }, 2000)

                    this.timeOut.setTimeoutWithKey("delete", idTimeOut);
                }, 100);
                this.timeOut.setTimeoutWithKey("delete", showTimeOut);

                if (response.class === "success") {
                    otpValide.value = false;
                    isAuthenticated.value = false;
                    requestDeleteCustomer.value = false

                    router.push({ path: '/' })
                }

                return response;
            })
            .catch(error => {
                alertMessageHappy.value = this.messageCatchError;

                const showTimeOut = setTimeout(() => {
                    showAlertMessageHappy.value = true;
                }, 100);
                this.timeOut.setTimeoutWithKey("show", showTimeOut);

                const idTimeOut = setTimeout(() => {
                    showAlertMessageHappy.value = false;
                    setTimeout(() => {
                        alertMessageHappy.value = alertMessageEmptyHappy
                    }, 500)
                }, 2000)
                this.timeOut.setIdTimeout(idTimeOut);
            })
    }
}